export default __webpack_public_path__ + "static/media/twitter.c2eba17f.svg";